import { useEffect } from "react";
import { useHistory } from "react-router-dom";

function OrderFinish() {
  const history = useHistory();

  useEffect(() => {
    history.push(`/`);
  }, [history]);

  return null;
}

export default OrderFinish;